module.exports = __webpack_public_path__ + "img/face70.f23d751f.gif";